import FilterItem from "./FilterItem.vue";
import MatchTypeFilterBody from "./bodies/MatchTypeFilterBody.vue";
import MatchTypeValue from "@/components/tableElements/MatchTypeValue.vue";
import FiltersMixin from "@/mixins/FiltersMixin.vue";
import { truncateString } from "@/utils";
export default {
  name: "MatchTypeFilter",
  components: {
    FilterItem,
    MatchTypeFilterBody,
    MatchTypeValue
  },
  emits: ["apply", "cleared"],
  expose: ["openDropdown"],
  mixins: [FiltersMixin],
  props: {
    match_types: {
      type: Object,
      required: true,
      default: () => ({
        filterState: {
          selected: [],
          list: []
        },
        isModified: false,
        select: () => {},
        deselect: () => {},
        clear: () => {},
        apply: () => {},
        listSearch: () => {}
      })
    }
  },
  data() {
    return {
      icons: {
        DEFAULT: 'EqualsIcon',
        EXACT: 'TargetIcon',
        TARGETING_EXPRESSION: 'BracketsPlusIcon',
        TARGETING_EXPRESSION_PREDEFINED: 'BracketsCheckIcon',
        BROAD: 'ZoomOutIcon',
        PHRASE: 'MessageSquareIcon'
      }
    };
  },
  computed: {
    getMatchTypeTitle() {
      return this.getMatchType?.name ?? "Match type";
    },
    getMatchType() {
      return this.match_types.selected?.[0];
    },
    getMatchTypeSelectedTitle() {
      const joined = this.match_types.selected?.map(el => el?.name).join(", ");
      return joined ? truncateString(joined, 200) : "";
    },
    getMatchTypeIcon() {
      const topMatchType = this.getMatchType;
      if (!topMatchType) return this.icons.DEFAULT;
      //console.log('top', topMatchType);
      return this.icons[topMatchType.type];
    }
  },
  methods: {
    onSelect({
      id
    }) {
      this.match_types.select({
        id
      }, 'id');
    },
    onSelectOnly({
      id
    }) {
      this.match_types.selectOnly({
        id
      }, 'id');
    },
    onDeSelect({
      id
    }) {
      this.match_types.deselect({
        id
      }, 'id');
      if (this.match_types?.filterState?.selected.length === 0) {
        this.$emit('cleared');
      }
    },
    onClear() {
      this.match_types.clear();
      this.$emit('cleared');
    },
    onDiscard() {
      // Revert the staged pending changes back to the last-applied selection.
      this.match_types.clearDraft();
    },
    onHidden() {
      this.match_types.clearDraft();
    },
    onRestoreSearch() {
      this.match_types.restoreSearch();
    },
    onApply() {
      this.$emit('apply');
    },
    onSearch({
      value
    }) {
      this.match_types.listSearch(value, ['name']);
    },
    onClose() {
      this.$refs?.matchTypeFilterItem?.closeDropdown();
    },
    openDropdown(initializer = async () => {}, callback = () => {}) {
      this.openAsyncFilterDropdown(this.$refs.matchTypeFilterItem, initializer, callback);
    }
  }
};